import React, { useState } from "react";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import TextFieldCustom from "../../../component/elements/textfieldCustom";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";

function CreateBroadcast({ onClose, onSubmit }) {
     const showSnackbar = useSnackbar();
    const [values, setValues] = useState({
        title: "",
        message: "",
    });
    const handleChange = (field, value) => {
        setValues((prev) => ({ ...prev, [field]: value }));
    };
    const handleSubmit = async () => {
        if (!values.title.trim() || !values.message.trim()) {
            showSnackbar("Both Title and Message are required", "error");
            return;
        }
        let payload = {
            title: values.title,
            message: values.message
        }

        axiosInstance
            .post(`/customer/delivery-person/broadcast`, payload)
            .then(() => {
                showSnackbar("Broadcast created successfully!", "success");
                    onSubmit();
            })
            .catch((error) => {
                showSnackbar(
                    error?.response?.data?.message || "Failed to create broadcast!",
                    "error"
                );
            })

    };

    return (
        <div className="pt-6 px-10">
            {/* Header */}
            <div className="flex justify-between mb-6">
                <div className="text-lg font-[500]">Broadcast message</div>
                <button
                    className="text-gray-600 hover:text-black"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <CloseIcon />
                </button>
            </div>

            {/* Form */}
            <div className="flex flex-col my-4 w-full justify-center items-center">
                <div className="flex flex-col gap-4 w-full items-center">
                    <TextFieldCustom
                        label="Title"
                        value={values.title}
                        onChange={(e) => handleChange("title", e.target.value)}
                        fullWidth
                    />

                    <TextFieldCustom
                        label="Message"
                        value={values.message}
                        onChange={(e) => handleChange("message", e.target.value)}
                        fullWidth
                        multiline
                        rows={2}
                        heightClass="custom-textarea-height"
                    />
                </div>

                {/* Buttons */}
                <div className="flex flex-col sm:flex-row justify-center items-center mt-8 mb-4 gap-3">
                    <CustomButton
                        onClick={handleSubmit}
                        disabled={!values.title.trim() || !values.message.trim()}
                        customeClass={`gradient-button w-[150px] h-[40px] ${!values.title.trim() || !values.message.trim()
                            ? "opacity-60 cursor-not-allowed"
                            : ""
                            }`}
                    >
                        Submit
                    </CustomButton>
                </div>
            </div>
        </div>
    );
}

export default CreateBroadcast;
